import logo from '../../assets/blinkscribe.png';
import bmlogo from '../../assets/bm_logo.png'

const TemplatePreview = ({ data }) => {
    if (!data || typeof data !== 'object' || Array.isArray(data)) {
        return (
            <div className="flex flex-col items-center justify-center w-full p-4 h-[100%]">
                <p className="text-red-500 text-lg font-semibold">
                    Something went wrong. Please provide valid data.
                </p>
            </div>
        );
    }

    const renderData = (data) => {
    if (!data || typeof data !== 'object') {
        return (
            <p className="text-xs text-gray-600 break-words overflow-hidden max-w-full">
                {JSON.stringify(data)}
            </p>
        );
    }

    return Object.entries(data).map(([key, value]) => (
        <div key={key} className="flex flex-col text-start mb-4 w-full">
            <p
                className="text-xs mb-1"
                dangerouslySetInnerHTML={{
                    __html: `<strong>${key.replace(/_/g, " ")}:</strong><br>`,
                }}
            ></p>

            {typeof value === 'object' && value !== null ? (
                Array.isArray(value) ? (
                    <ul className="pl-4 list-disc text-xs text-gray-600">
                        {value.length > 0 ? (
                            value.map((item, index) => (
                                <li key={index} className="break-words">
                                    {typeof item === 'object'
                                        ? renderData(item)
                                        : JSON.stringify(item)}
                                </li>
                            ))
                        ) : (
                            <li>No content available</li>
                        )}
                    </ul>
                ) : (
                    <div className="pl-4 border-l-2 border-gray-300">
                        {renderData(value)}
                    </div>
                )
            ) : (
                <p
                    className="text-xs text-gray-600 break-words overflow-hidden max-w-full"
                    dangerouslySetInnerHTML={{
                        __html:
                            typeof value === 'string'
                                ? value.replace(/\n/g, "<br>") + "<br><br>"
                                : typeof value === 'number' || typeof value === 'boolean'
                                ? String(value) + "<br><br>"
                                : value === null
                                ? 'null<br><br>'
                                : typeof value === 'undefined'
                                ? 'undefined<br><br>'
                                : JSON.stringify(value) + "<br><br>",
                    }}
                ></p>
            )}
        </div>
    ));
};


    return (<>

        {/* Outer Card */}
        <div className="flex flex-col items-start w-full bg-white shadow-lg border border-gray-300 rounded-xl p-6">
          {/* Inner Card */}
          <div className="flex flex-col items-start w-full bg-white shadow-[0px_0px_4px_0px_rgba(0,0,0,0.25)] h-[500px] p-4 border border-gray-300 rounded-lg overflow-hidden">
            {/* Header with Logo */}
            {/* <div className="flex items-center justify-center w-full">
              <img src={logo} alt="logo" className="h-6" />
            </div> */}

            {/* Horizontal Line */}
            {/* <div className="w-full mt-4">
              <hr className="w-full border-t-2 border-gray-300 my-2" />
            </div> */}

            {/* Content Section */}
            <div className="flex flex-col items-start justify-start w-full mt-4 overflow-y-auto h-auto custom-scrollbar">
              {Object.keys(data).length === 0 ? (
                <p className="text-gray-500 text-sm text-center">No data available.</p>
              ) : (
                <>{renderData(data)}</>
              )}
            </div>

            {/* Footer */}
            {/* <div className="mt-6 w-full flex flex-col gap-2 items-center justify-center">
              <div className="text-xs font-medium [font-family:'Poppins-Medium',Helvetica] text-black tracking-[0] leading-[normal] whitespace-nowrap text-center">
                Generated By
              </div>
              <img src={bmlogo} alt="logo" className="h-6" />
            </div> */}
          </div>
        
      </div></>
    );
};

export default TemplatePreview;
